import { logEvent } from "@/service/logs/log";
import { createPath } from "@/service/routing/routing";
import { useContext } from "react";
import { ResourceContext } from "@/contexts/resource-context";
import { ClinicalCaseCard } from "@/components/clinical-case/clinical-case-card";

export const Icd10ClinicalCaseCard = ({
  clinicalCase,
  code,
}: {
  clinicalCase: ClinicalCasePreviewVM;
  code: string;
}) => {
  const { logView } = useContext(ResourceContext);

  return (
    <ClinicalCaseCard
      clinicalCase={clinicalCase}
      onClick={() => {
        logEvent("icd10_internal_link_click", logView, {
          icd_code: code,
          resource_path: createPath("clinical_case.show", {
            category: clinicalCase.category.slug,
            slug: clinicalCase.slug,
          }),
          resource_type: "clinical_case",
        });
      }}
    />
  );
};
